import { abs, origin } from "@/lib/site";

export const Seo = ({ title, description, path = "/", image = "/og.png", type = "website", jsonLd = [], noindex = false }) => {
  const full = title ? `${title} | the suspects` : "the suspects | Good People. Sus Ideas. Toronto Streetwear";
  const url = origin() + path;
  const img = abs(image);
  return (
    <>
      <title>{full}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="the suspects" />
      <meta property="og:locale" content="en_CA" />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd.map((j, i) => (
        <script key={i} type="application/ld+json" data-testid="json-ld" dangerouslySetInnerHTML={{ __html: JSON.stringify(j) }} />
      ))}
    </>
  );
};
